import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TrackingForm from './components/TrackingForm';
import AdminManage from './components/AdminManage';
import Analytics from './components/Analytics';
import './App.css';

function App() {
  console.log('App component rendering');
  
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<TrackingForm />} />
          <Route path="/admin-manage" element={<AdminManage />} />
          <Route path="/admin" element={<AdminManage />} />
          <Route path="/admin/analytics" element={<Analytics />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
